function buildItemListName(t) {
  return [t.item_category, t.item_category2, t.item_category3]
    .filter(Boolean)
    .join("-");
}
function pushViewItem() {
  if (window.productItemData) {
    window.productItemData.item_list_name = buildItemListName(
      window.productItemData,
    );
    try {
      var t,
        e = "tracking_last_selected:" + window.productItemData.handle,
        a = sessionStorage.getItem(e);
      a &&
        ("number" == typeof (t = JSON.parse(a)).index &&
          (window.productItemData.index = t.index),
        t.item_list_name &&
          (window.productItemData.item_list_name = t.item_list_name),
        sessionStorage.removeItem(e));
    } catch (t) {}
    try {
      sessionStorage.setItem(
        "tracking_ctx:" + window.productItemData.handle,
        JSON.stringify({
          index: window.productItemData.index,
          item_list_name: window.productItemData.item_list_name,
        }),
      );
    } catch (t) {}
    ((window.dataLayer = window.dataLayer || []),
      window.dataLayer.push({ ecommerce: null }),
      window.dataLayer.push({
        event: "view_item",
        ecommerce: {
          currency: window.productCurrency || window.pageContext?.currency,
          value: window.productItemData.price,
          items: [window.productItemData],
        },
      }));
  }
}
("loading" === document.readyState
  ? document.addEventListener("DOMContentLoaded", pushViewItem)
  : pushViewItem(),
  window.addEventListener("pageshow", function (t) {
    t.persisted && pushViewItem();
  }),
  (() => {
    function a() {
      ((window.dataLayer = window.dataLayer || []),
        window.dataLayer.push({ event: "show_mini_cart" }),
        "function" == typeof window.trackingFetchViewCart &&
          window.trackingFetchViewCart());
    }
    let n = document.getElementById("mini-cart-modal"),
      i =
        (n &&
          new MutationObserver(function (t) {
            for (var e of t)
              "attributes" === e.type &&
                "style" === e.attributeName &&
                "none" !== n.style.display &&
                a();
          }).observe(n, { attributes: !0, attributeFilter: ["style"] }),
        document.getElementById("cart-drawer"));
    i &&
      new MutationObserver(function (t) {
        for (var e of t)
          "attributes" === e.type &&
            "open" === e.attributeName &&
            i.hasAttribute("open") &&
            a();
      }).observe(i, { attributes: !0, attributeFilter: ["open"] });
  })(),
  (() => {
    function t(t, e, a) {
      ((window.dataLayer = window.dataLayer || []),
        window.dataLayer.push({ ecommerce: null }),
        window.dataLayer.push({
          event: "view_cart",
          ecommerce: {
            currency: t,
            value: e,
            items: a.map(function (t) {
              var e = i(t.handle);
              return Object.assign({}, t, {
                index: e ? e.index : t.index || 0,
                item_list_name: (e && e.item_list_name) || n(t),
              });
            }),
          },
        }));
    }
    let n = function (t) {
        return [t.item_category, t.item_category2, t.item_category3]
          .filter(Boolean)
          .join("-");
      },
      i = function (t) {
        try {
          var e = sessionStorage.getItem("tracking_ctx:" + t);
          return e ? JSON.parse(e) : null;
        } catch (t) {
          return null;
        }
      };
    ((window.trackingFetchViewCart = function () {
      window.cartData &&
        t(
          window.cartData.currency,
          window.cartData.value,
          window.cartData.items,
        );
    }),
      window.pageContext &&
        "cart" === window.pageContext.page_type &&
        t(
          window.cartData.currency,
          window.cartData.value,
          window.cartData.items,
        ));
  })(),
  (() => {
    var t = document.getElementById("search-drawer");
    if (t) {
      let a = t.querySelector('input[name="q"]');
      if (a) {
        let e = null;
        a.addEventListener("input", function () {
          let t = a.value.trim();
          (clearTimeout(e),
            t &&
              (e = setTimeout(function () {
                ((window.dataLayer = window.dataLayer || []),
                  window.dataLayer.push({
                    event: "search_results",
                    search_position: "search_bar",
                    search_term: t,
                  }));
              }, 500)));
        });
      }
    }
  })(),
  (() => {
    function o(t, e) {
      e &&
        ((window.dataLayer = window.dataLayer || []),
        window.dataLayer.push({
          event: "clic",
          click_position: t,
          click_name: e,
        }));
    }
    function r(t) {
      return t
        ? ((t = t.cloneNode(!0))
            .querySelectorAll(".sr-only, svg, img, cart-count, .count-bubble")
            .forEach(function (t) {
              t.remove();
            }),
          t.textContent.trim().replace(/\s+/g, " ").toLowerCase())
        : "";
    }
    function i(t) {
      return (t = t.toLowerCase()).includes("color") ||
        t.includes("colour") ||
        t.includes("colo") ||
        t.includes("colore")
        ? "colour:"
        : t.includes("size") || t.includes("taglia")
          ? "size:"
          : t
            ? c(t) + ":"
            : "";
    }
    function t(t, e) {
      return (
        (t = (t = t.split("."))[t.length - 1].toLowerCase()),
        i(t) + c(e)
      );
    }
    let c = function (t) {
        return t
          .toLowerCase()
          .replace(/'/g, "")
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-+|-+$/g, "");
      },
      e =
        (document.addEventListener("click", function (e) {
          e = e.target.closest("a, button");
          if (e) {
            var t = e.closest("store-header, .header, #shopify-section-header");
            if (
              t &&
              !e.closest(
                "nav, navigation-drawer, .navigation-drawer, .mega-menu, .dropdown-menu",
              )
            ) {
              let t = null;
              (e.closest('[aria-controls="search-drawer"]')
                ? (t = "search")
                : e.classList.contains("swym-wishlist") ||
                    e.closest(".swym-wishlist")
                  ? (t = "wishlist")
                  : e.classList.contains("card-drawer-button") ||
                      e.closest(".card-drawer-button")
                    ? (t = "minicart")
                    : e.href && e.href.includes("account") && (t = "account"),
                t && o("header", t));
            }
          }
        }),
        document.addEventListener("click", function (t) {
          var e,
            a,
            n,
            i,
            t = t.target.closest("a, button, summary");
          t &&
            ((i = t.closest("nav.header__link-list")),
            (e = t.closest(
              "navigation-drawer#header-sidebar-menu, .jkl-mobile-nav, .jkl-mobile-drawer",
            )),
            (a = t.closest(".mega-menu, .jkl-mega-menu-wrapper")),
            (n = t.closest(".dropdown-menu")),
            i || e || a || n) &&
            (i = r(t)) &&
            (!!t.closest(
              ".dropdown-menu, .mega-menu, .jkl-mega-menu-wrapper, .jkl-visual-tab-content",
            )
              ? o("menu", "secondLevel - " + c(i))
              : o("menu", "firstLevel - " + i.toUpperCase()));
        }),
        document.addEventListener("click", function (e) {
          e = e.target.closest("button, label, a");
          if (e) {
            var a = e.closest(
              "[is='facet-form'], facet-sort-by, facet-dialog, x-popover, .facets-horizontal, .facets-vertical, .facet-dialog",
            );
            if (a)
              if (
                "option" === e.getAttribute("role") &&
                e.closest("x-popover, x-listbox")
              )
                ((a = e.getAttribute("value") || r(e)),
                  o("filter", "sort:" + c(a)));
              else if (
                e.getAttribute("aria-controls") &&
                e.getAttribute("aria-controls").startsWith("filter-dialog-")
              )
                ((a = r(e)), o("filter", c(a)));
              else {
                var a = e.classList.contains("color-swatch")
                  ? e
                  : e.closest(".color-swatch");
                if (a)
                  ((n = (n = a.closest(".color-swatch-container"))
                    ? n.previousElementSibling
                    : a.htmlFor
                      ? document.getElementById(a.htmlFor)
                      : null),
                    (a =
                      r(a)
                        .replace(/\(\d+\)\s*$/, "")
                        .trim() ||
                      (a.getAttribute("data-tooltip") || "")
                        .trim()
                        .toLowerCase()),
                    n
                      ? o("filter", t(n.getAttribute("name") || "", a))
                      : a && o("filter", "colour:" + c(a)));
                else if (
                  "LABEL" === e.tagName &&
                  e.classList.contains("facet-dialog-option")
                ) {
                  var n = e.closest("facet-dialog");
                  let t = "";
                  n &&
                    (a = (n.id || "").match(
                      /filter\.(?:v\.option|p\.m\.[^.]+)\.([^.]+)$/i,
                    )) &&
                    (t = i(a[1].toLowerCase()));
                  var n = r(e)
                    .replace(/\(\d+\)\s*$/, "")
                    .trim();
                  void o("filter", t + c(n));
                } else
                  "LABEL" === e.tagName &&
                    e.htmlFor &&
                    (a = document.getElementById(e.htmlFor)) &&
                    ("sort_by" === (n = a.getAttribute("name") || "")
                      ? ((a = a.value || r(e)), o("filter", "sort:" + c(a)))
                      : n.startsWith("filter.") &&
                        ((a = r(e)
                          .replace(/\(\d+\)\s*$/, "")
                          .trim()),
                        o("filter", t(n, a))));
              }
          }
        }),
        document.addEventListener("click", function (t) {
          var e,
            t = t.target.closest("button, a, [role='button']");
          t &&
            (t.closest("newsletter-popup, .newsletter-drawer")
              ? ("submit" !== t.type && !t.closest('[type="submit"]')) ||
                o("banner", "newsletter")
              : t.closest(
                    '[data-testid="form-component"], [data-component="form-component"]',
                  )
                ? (e = (
                    t.getAttribute("aria-label") || ""
                  ).toLowerCase()).includes("close") ||
                  e.includes("chiudi") ||
                  o("banner", "newsletter")
                : t.closest(
                    ".shopify-section--jkl-account-hero-banner, jkl-account-hero-banner, .account-hero-banner",
                  ) && o("banner", "the colors club"));
        }),
        document.addEventListener("click", function (t) {
          var e,
            t = t.target.closest("button, a");
          t &&
            t.closest(
              "#mini-cart-modal, .mini-cart-modal, #cart-drawer, cart-drawer",
            ) &&
            (t.classList.contains("line-item__qty-btn")
              ? ((e = t.getAttribute("data-change")),
                o("minicart", "1" === e ? "add quantity" : "remove quantity"))
              : t.classList.contains("line-item__close-btn") ||
                  t.closest(".line-item__close-btn")
                ? o("minicart", "remove product")
                : "checkout" === t.getAttribute("name") || "submit" === t.type
                  ? o("minicart", "go to checkout")
                  : "A" === t.tagName &&
                    t.href &&
                    t.href.includes("/cart") &&
                    o("minicart", "go to cart"));
        }),
        document.addEventListener("click", function (t) {
          var e = t.composedPath ? t.composedPath() : [],
            a = e.find(function (t) {
              return (
                1 === t.nodeType &&
                ("close-button" === t.getAttribute("part") ||
                  "outside-close-button" === t.getAttribute("part"))
              );
            });
          if (
            a &&
            e.find(function (t) {
              return (
                t.tagName &&
                "cart-notification-drawer" === t.tagName.toLowerCase()
              );
            })
          )
            return void o("add to cart feedback", "close");
          a = t.target.closest("a, button");
          a &&
            a.closest("cart-notification-drawer") &&
            ("checkout" === a.getAttribute("name") || "submit" === a.type
              ? o("add to cart feedback", "go to checkout")
              : "A" === a.tagName && a.href && a.href.includes("/cart")
                ? o("add to cart feedback", "go to cart")
                : ("close-button" !== a.getAttribute("is") &&
                    !a.closest('[is="close-button"]')) ||
                  o("add to cart feedback", "close"));
        }),
        document.addEventListener("click", function (t) {
          var e,
            t = t.target.closest("button, a, summary");
          t &&
            t.closest(
              ".main-product, #shopify-section-jkl-main-product, [id*='jkl-main-product'], .product-info",
            ) &&
            (t.classList.contains("size-chart-button") ||
            t.closest(".size-chart-button")
              ? o("PDP", "size guide")
              : (t = t.classList.contains("accordion-info__trigger")
                  ? t
                  : t.closest(".accordion-info__trigger")) &&
                (e = (e = t.querySelector(".accordion-info__title"))
                  ? r(e)
                  : r(t)) &&
                o("PDP", "product info - " + e));
        }),
        document.addEventListener("click", function (t) {
          t = t.target.closest("button, a");
          t &&
            t.closest("jkl-shop-by-color, .jkl-shop-by-color") &&
            (t.classList.contains("jkl-shop-by-color__play-again") ||
            t.closest(".jkl-shop-by-color__play-again")
              ? o("carousel", "shop by color - play again")
              : t.classList.contains("jkl-shop-by-color__nav-button") ||
                  t.closest(".jkl-shop-by-color__nav-button")
                ? o("carousel", "shop by color - arrow")
                : (t.classList.contains("jkl-shop-by-color__start-btn") ||
                    t.closest(".jkl-shop-by-color__start-btn")) &&
                  o("carousel", "shop by color - start from here"));
        }),
        {
          "asymmetric-four": "four-col-layout-big",
          asymmetric: "asymmetric",
          symmetric: "four-col-layout",
        });
    (document.addEventListener("click", function (t) {
      var t = t.target.closest(".btn-collection-layout");
      t &&
        ((t = t.getAttribute("data-layout")),
        (t = e[t] || c(t)),
        o("toggle layout", t));
    }),
      document.addEventListener("click", function (e) {
        e = e.target.closest("a, button");
        if (e) {
          var a = e.closest(
            ".footer, #shopify-section-jkl-footer, [id*='jkl-footer']",
          );
          if (a)
            if (
              e.closest("#footer-newsletter") &&
              ("submit" === e.type || e.closest('[type="submit"]'))
            )
              o("footer", "newsletter");
            else if (e.classList.contains("footer__links-item")) {
              var a = e.closest(
                ".footer__links-column, .footer__links-column-last",
              );
              let t = "";
              a && (a = a.querySelector(".footer__links-title")) && (t = r(a));
              ((a = r(e)), (e = t ? t + " - " + a : a));
              o("footer", e);
            }
        }
      }),
      document.addEventListener("click", function (t) {
        t = t.target.closest("button, [type='submit']");
        t &&
          t.closest("form[id^='newsletter-form-']") &&
          !t.closest(
            ".footer, #shopify-section-jkl-footer, [id*='jkl-footer']",
          ) &&
          o("CTA", "newsletter");
      }));
  })(),
  (() => {
    var t = window.productSizeOptionPosition;
    if (t) {
      let a = "option" + t,
        n = null,
        i = 0;
      document.addEventListener("variant:change", function (t) {
        var e,
          t = t.detail?.variant;
        t &&
          (t = t[a]) &&
          ((e = Date.now()),
          (t === n && e - i < 500) ||
            ((n = t),
            (i = e),
            (window.dataLayer = window.dataLayer || []),
            window.dataLayer.push({
              event: "size_choose",
              click_position: "product page",
              size: t,
            })));
      });
    }
  })(),
  document.addEventListener("click", function (t) {
    var e,
      t = t.target.closest(".color-swatch");
    t &&
      !t.classList.contains("is-disabled") &&
      ((e = t.closest("product-card") ? "product card" : "product page"),
      (t = ((t) => {
        var e = t.getAttribute("data-color");
        if (e) return e.trim();
        if ((e = t.getAttribute("data-tooltip"))) return e.trim();
        if ((e = t.closest("[data-variation-color]"))) {
          t = e.getAttribute("data-variation-color");
          if (t) return t.trim();
        }
        return "";
      })(t)),
      (window.dataLayer = window.dataLayer || []),
      window.dataLayer.push({
        event: "color_choose",
        click_position: e,
        color: t,
      }));
  }),
  (() => {
    function n(t) {
      t.forEach(function (t) {
        r.has(t.handle) || (r.add(t.handle), o.push(t));
      });
    }
    function a() {
      return o.map(function (t, e) {
        return Object.assign({}, t, { index: e });
      });
    }
    function i(t) {
      ((window.dataLayer = window.dataLayer || []),
        window.dataLayer.push({ ecommerce: null }),
        window.dataLayer.push({
          event: "view_item_list",
          ecommerce: { item_list_name: c, items: t || a() },
        }));
    }
    let o = [],
      r = new Set(),
      c = "";
    function t() {
      var t = window.collectionData || window.searchResultsData;
      t && ((o = []), (r = new Set()), (c = t.item_list_name), n(t.items), i());
    }
    (document.addEventListener("collection:load-more", function (t) {
      let e = (t.detail && t.detail.handles) || [];
      if (e.length) {
        ((t = window.collectionData || window.searchResultsData),
          (t = ((t && t.items) || []).filter(function (t) {
            return e.includes(t.handle) && !r.has(t.handle);
          })));
        if (t.length) {
          let a = o.length;
          n(t);
          t = t.map(function (t, e) {
            return Object.assign({}, t, { index: a + e });
          });
          i(t);
        }
      }
    }),
      t(),
      document.addEventListener("collection:changed", t),
      document.addEventListener("tracking:collection:init", t),
      document.addEventListener("click", function (t) {
        if (!t.target.closest(".color-swatch-container")) {
          t = t.target.closest("product-card a[href]");
          if (t) {
            t = t.closest("product-card[handle]");
            if (t) {
              let e = t.getAttribute("handle");
              t = a().find(function (t) {
                return t.handle === e;
              });
              if (t) {
                try {
                  sessionStorage.setItem(
                    "tracking_last_selected:" + e,
                    JSON.stringify({ index: t.index, item_list_name: c }),
                  );
                } catch (t) {}
                ((window.dataLayer = window.dataLayer || []),
                  window.dataLayer.push({ ecommerce: null }),
                  window.dataLayer.push({
                    event: "select_item",
                    ecommerce: { item_list_name: c, items: [t] },
                  }));
              }
            }
          }
        }
      }));
  })(),
  (() => {
    function n(e) {
      var t;
      a.has(e) ||
        ((t = (window.collectionTabsData || []).find(function (t) {
          return t.panelId === e;
        })) &&
          t.items &&
          t.items.length &&
          (a.add(e), i(t)));
    }
    let a = new Set(),
      i = function (t) {
        ((window.dataLayer = window.dataLayer || []),
          window.dataLayer.push({ ecommerce: null }),
          window.dataLayer.push({
            event: "view_item_list",
            ecommerce: { item_list_name: t.item_list_name, items: t.items },
          }));
      };
    function t() {
      var t = window.collectionTabsData || [];
      if (t.length) {
        let a = new IntersectionObserver(
          function (t) {
            t.forEach(function (t) {
              var e;
              t.isIntersecting &&
                ((e = t.target.id), n(e), a.unobserve(t.target));
            });
          },
          { threshold: 0.1 },
        );
        (t.forEach(function (t) {
          t = document.getElementById(t.panelId);
          t && !t.hidden && a.observe(t);
        }),
          document.addEventListener("click", function (e) {
            e = e.target.closest(".collection-tabs__tab-button[aria-controls]");
            if (e) {
              let t = e.getAttribute("aria-controls");
              t &&
                setTimeout(function () {
                  n(t);
                }, 0);
            }
          }),
          document.addEventListener("click", function (t) {
            if (!t.target.closest(".color-swatch-container")) {
              t = t.target.closest("product-card a[href]");
              if (t) {
                t = t.closest("product-card[handle]");
                if (t) {
                  var a = t.closest(".collection-tabs__tab-panel");
                  if (a) {
                    let e = a.id;
                    a = (window.collectionTabsData || []).find(function (t) {
                      return t.panelId === e;
                    });
                    if (a) {
                      let e = t.getAttribute("handle");
                      t = a.items.find(function (t) {
                        return t.handle === e;
                      });
                      if (t) {
                        try {
                          sessionStorage.setItem(
                            "tracking_last_selected:" + e,
                            JSON.stringify({
                              index: t.index,
                              item_list_name: a.item_list_name,
                            }),
                          );
                        } catch (t) {}
                        ((window.dataLayer = window.dataLayer || []),
                          window.dataLayer.push({ ecommerce: null }),
                          window.dataLayer.push({
                            event: "select_item",
                            ecommerce: {
                              item_list_name: a.item_list_name,
                              items: [t],
                            },
                          }));
                      }
                    }
                  }
                }
              }
            }
          }));
      }
    }
    "loading" === document.readyState
      ? document.addEventListener("DOMContentLoaded", t)
      : t();
  })(),
  (() => {
    function e(t) {
      var e = (e = document.querySelector(
        '.shopify-section-cart-drawer, [id^="shopify-section-"][id*="cart-drawer"]',
      ))
        ? e.id.replace("shopify-section-", "")
        : null;
      e &&
        t &&
        t[e] &&
        ((t = t[e]),
        new DOMParser()
          .parseFromString(t, "text/html")
          .querySelectorAll("script")
          .forEach(function (t) {
            var e;
            t.textContent.includes("window.cartData") &&
              (((e = document.createElement("script")).textContent =
                t.textContent),
              document.head.appendChild(e),
              e.remove());
          }));
    }
    document.documentElement.addEventListener("cart:change", function (t) {
      t.detail && t.detail.cart && e(t.detail.cart.sections);
    });
  })(),
  (() => {
    if (
      window.themeVariables &&
      window.themeVariables.settings &&
      "cart" === window.themeVariables.settings.pageType
    ) {
      let i = window.fetch;
      window.fetch = function () {
        var t;
        if (
          !(
            ("string" == typeof arguments[0]
              ? arguments[0]
              : (arguments[0] && arguments[0].url) || ""
            ).includes("/cart/update") &&
            arguments[1] &&
            arguments[1].body
          )
        )
          return i.apply(this, arguments);
        let e = [];
        try {
          var a = JSON.parse(arguments[1].body);
          "string" == typeof a.discount &&
            (e = (t = a.discount)
              ? String(t)
                  .split(",")
                  .map(function (t) {
                    return t.trim().toLowerCase();
                  })
                  .filter(Boolean)
              : []);
        } catch (t) {
          return i.apply(this, arguments);
        }
        if (!e.length && void 0 === JSON.parse(arguments[1].body).discount)
          return i.apply(this, arguments);
        let n =
          window.cartData && Array.isArray(window.cartData.discount_codes)
            ? window.cartData.discount_codes
                .filter(function (t) {
                  return t.applicable;
                })
                .map(function (t) {
                  return t.code.toLowerCase();
                })
            : [];
        return i.apply(this, arguments).then(function (t) {
          return (
            t
              .clone()
              .json()
              .then(function (t) {
                t &&
                  Array.isArray(t.discount_codes) &&
                  t.discount_codes
                    .filter(function (t) {
                      return (
                        t.applicable && -1 === n.indexOf(t.code.toLowerCase())
                      );
                    })
                    .forEach(function (t) {
                      ((window.dataLayer = window.dataLayer || []),
                        window.dataLayer.push({
                          event: "apply_coupon",
                          coupon: t.code,
                        }));
                    });
              })
              .catch(function () {}),
            t
          );
        });
      };
    }
  })(),
  (() => {
    function a(t, n) {
      let i = {},
        o =
          (((window.cartData && window.cartData.items) || []).forEach(
            function (t) {
              i[t.key] = t;
            },
          ),
          []),
        e;
      (t.forEach(function (t) {
        var e,
          a = Object.prototype.hasOwnProperty.call(n, t.key) ? n[t.key] : 0,
          a = t.quantity - a;
        a <= 0 ||
          ((t = i[t.key]) &&
            o.push(
              ((t = t),
              (a = a),
              (e = c(t.handle)),
              ((a = {
                item_id: t.item_id,
                item_name: t.item_name,
                item_brand: t.item_brand || "",
                coupon: t.coupon || "",
                discount: t.discount || 0,
                index: e ? e.index : t.index || 0,
                item_category: t.item_category || "",
                item_category2: t.item_category2 || "",
                item_category3: t.item_category3 || "",
                item_list_name: "",
                variant: t.variant || "",
                size: t.size || "",
                price: t.price || 0,
                quantity: a,
                sale: t.sale || "",
                perc_size_available: t.perc_size_available || "",
                size_not_available: t.size_not_available || "",
                season: t.season || "",
                new_arrival: t.new_arrival || "",
                continuos_product: t.continuos_product || "",
                brand_real: t.brand_real || "",
                handle: t.handle || "",
              }).item_list_name = (e && e.item_list_name) || r(a)),
              a),
            ));
      }),
        o.length &&
          ((t = o.reduce(function (t, e) {
            return t + e.price * e.quantity;
          }, 0)),
          (e =
            (window.cartData && window.cartData.currency) ||
            window.productCurrency ||
            window.pageContext?.currency),
          (window.dataLayer = window.dataLayer || []),
          window.dataLayer.push({ ecommerce: null }),
          window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: { currency: e, value: t, items: o },
          }),
          Shopify.analytics.publish("custom_add_to_cart", {
            currency: e,
            value: t,
            items: o,
          })));
    }
    function n() {
      ((i = {}),
        ((window.cartData && window.cartData.items) || []).forEach(
          function (t) {
            i[t.key] = t.quantity;
          },
        ));
    }
    let r = function (t) {
        return [t.item_category, t.item_category2, t.item_category3]
          .filter(Boolean)
          .join("-");
      },
      c = function (t) {
        try {
          var e = sessionStorage.getItem("tracking_ctx:" + t);
          return e ? JSON.parse(e) : null;
        } catch (t) {
          return null;
        }
      },
      i = {},
      o =
        (n(),
        document.addEventListener("line-item:will-change", function () {
          n();
        }),
        window.fetch);
    ((window.fetch = function () {
      var t = (
          "string" == typeof arguments[0]
            ? arguments[0]
            : (arguments[0] && arguments[0].url) || ""
        ).includes("/cart/change"),
        t =
          (t && n(),
          t &&
            window.themeVariables &&
            window.themeVariables.settings &&
            "cart" === window.themeVariables.settings.pageType),
        e = o.apply(this, arguments);
      return t
        ? e.then(function (t) {
            return (
              t
                .clone()
                .json()
                .then(function (t) {
                  a(t.items || [], i);
                }),
              t
            );
          })
        : e;
    }),
      document.documentElement.addEventListener("cart:change", function (t) {
        t.detail &&
          t.detail.cart &&
          ("line-item:change" === t.detail.baseEvent
            ? (a(t.detail.cart.items || [], i), n())
            : "variant:add" === t.detail.baseEvent && n());
      }),
      document.addEventListener("variant:add", function (t) {
        var e,
          a,
          t = t.detail && t.detail.items;
        t &&
          t.length &&
          ((e = (t = t.map(function (t) {
            return (
              (e = (t = t).quantity),
              (a =
                window.productItemData &&
                window.productItemData.product_id == t.product_id
                  ? window.productItemData
                  : null),
              (n = t.variant_options || []),
              (n = ((i = window.productSizeOptionPosition) && n[i - 1]) || ""),
              (i = (a && a.variant) || ""),
              (o = c(t.handle)),
              ((i = {
                item_id: a ? a.item_id : t.product_id,
                item_name: t.product_title,
                item_brand: t.vendor,
                coupon: a ? a.coupon : "",
                discount: a ? a.discount : 0,
                index: o ? o.index : 0,
                item_category: a ? a.item_category : "",
                item_category2: a ? a.item_category2 : "",
                item_category3: a ? a.item_category3 : "",
                item_list_name: "",
                variant: i,
                size: n,
                price: t.price / 100,
                quantity: e || t.quantity,
                sale: a ? a.sale : "",
                perc_size_available: a ? a.perc_size_available : "",
                size_not_available: a ? a.size_not_available : "",
                season: a ? a.season : "",
                new_arrival: a ? a.new_arrival : "",
                continuos_product: a ? a.continuos_product : "",
                brand_real: a ? a.brand_real : "",
                handle: t.handle,
              }).item_list_name = (o && o.item_list_name) || r(i)),
              i
            );
            var e, a, n, i, o;
          })).reduce(function (t, e) {
            return t + e.price * e.quantity;
          }, 0)),
          (a = window.productCurrency || window.pageContext?.currency),
          (window.dataLayer = window.dataLayer || []),
          window.dataLayer.push({ ecommerce: null }),
          window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: { currency: a, value: e, items: t },
          }),
          Shopify.analytics.publish("custom_add_to_cart", {
            currency: a,
            value: e,
            items: t,
          }));
      }));
  })(),
  (() => {
    function a() {
      c = ((e) => {
        let a = {};
        return (
          Object.keys(e || {}).forEach(function (t) {
            a[t] = Object.assign({}, e[t]);
          }),
          a
        );
      })(
        (() => {
          let e = {};
          return (
            ((window.cartData && window.cartData.items) || []).forEach(
              function (t) {
                e[t.key] = t;
              },
            ),
            e
          );
        })(),
      );
    }
    function n(t) {
      let i = {};
      if (
        (t.forEach(function (t) {
          i[t.key] = t.quantity;
        }),
        c)
      ) {
        let n = [];
        (Object.keys(c).forEach(function (t) {
          var e = c[t],
            a = e.quantity,
            t = Object.prototype.hasOwnProperty.call(i, t) ? i[t] : 0;
          t < a &&
            n.push(
              ((e = e),
              (a = a - t),
              (t = r(e.handle)),
              {
                item_id: e.item_id,
                item_name: e.item_name,
                item_brand: e.item_brand || "",
                coupon: e.coupon || "",
                discount: e.discount || 0,
                index: t ? t.index : e.index || 0,
                item_category: e.item_category || "",
                item_category2: e.item_category2 || "",
                item_category3: e.item_category3 || "",
                item_list_name: (t && t.item_list_name) || o(e),
                variant: e.variant || "",
                size: e.size || "",
                price: e.price || 0,
                quantity: a,
                sale: e.sale || "",
                perc_size_available: e.perc_size_available || "",
                size_not_available: e.size_not_available || "",
                season: e.season || "",
                new_arrival: e.new_arrival || "",
                continuos_product: e.continuos_product || "",
                brand_real: e.brand_real || "",
                handle: e.handle || "",
              }),
            );
        }),
          n.length &&
            ((t = n.reduce(function (t, e) {
              return t + e.price * e.quantity;
            }, 0)),
            (window.dataLayer = window.dataLayer || []),
            window.dataLayer.push({ ecommerce: null }),
            window.dataLayer.push({
              event: "remove_from_cart",
              ecommerce: {
                currency:
                  (window.cartData && window.cartData.currency) ||
                  window.pageContext?.currency,
                value: t,
                items: n,
              },
            })));
      }
    }
    let o = function (t) {
        return [t.item_category, t.item_category2, t.item_category3]
          .filter(Boolean)
          .join("-");
      },
      r = function (t) {
        try {
          var e = sessionStorage.getItem("tracking_ctx:" + t);
          return e ? JSON.parse(e) : null;
        } catch (t) {
          return null;
        }
      },
      c = null,
      i =
        (document.addEventListener("line-item:will-change", function () {
          a();
        }),
        a(),
        window.fetch);
    ((window.fetch = function () {
      var t = (
          "string" == typeof arguments[0]
            ? arguments[0]
            : (arguments[0] && arguments[0].url) || ""
        ).includes("/cart/change"),
        t =
          (t && a(),
          t &&
            window.themeVariables &&
            window.themeVariables.settings &&
            "cart" === window.themeVariables.settings.pageType),
        e = i.apply(this, arguments);
      return t
        ? e.then(function (t) {
            return (
              t
                .clone()
                .json()
                .then(function (t) {
                  n(t.items || []);
                }),
              t
            );
          })
        : e;
    }),
      document.documentElement.addEventListener("cart:change", function (t) {
        t.detail &&
          t.detail.cart &&
          ("line-item:change" === t.detail.baseEvent
            ? (n(t.detail.cart.items || []), a())
            : "variant:add" === t.detail.baseEvent && a());
      }));
  })(),
  (() => {
    let o = [
        ".shopify-section--featured-items",
        ".shopify-section--look-spotlight",
      ].join(", "),
      i = {};
    function t() {
      let e = window._mpTrackingRegistry || {};
      Object.keys(e).forEach(function (t) {
        i[t] = e[t];
      });
    }
    ("loading" === document.readyState
      ? document.addEventListener("DOMContentLoaded", t)
      : t(),
      document.addEventListener("click", function (e) {
        e = e.target.closest(
          ".shopify-section--multi-product-showcase [data-mp-product-handle] a[href]",
        );
        if (e) {
          e = e.closest("[data-mp-product-handle]");
          if (e) {
            var a,
              n = e.getAttribute("data-mp-product-handle");
            if (n) {
              let t = i[n];
              if (
                ((t && t.item_name) ||
                  ((a = window.productItemData) &&
                    a.handle === n &&
                    ((t = Object.assign({}, a, {
                      index:
                        parseInt(e.getAttribute("data-mp-product-index"), 10) ||
                        0,
                      item_list_name: "multi-product-showcase",
                    })),
                    (i[n] = t))),
                t && t.item_name)
              ) {
                try {
                  sessionStorage.setItem(
                    "tracking_last_selected:" + n,
                    JSON.stringify({
                      index: t.index,
                      item_list_name: t.item_list_name,
                    }),
                  );
                } catch (t) {}
                ((window.dataLayer = window.dataLayer || []),
                  window.dataLayer.push({ ecommerce: null }),
                  window.dataLayer.push({
                    event: "select_item",
                    ecommerce: { item_list_name: t.item_list_name, items: [t] },
                  }));
              }
            }
          }
        }
      }));
    let r = function (t) {
        var e = window.collectionContext;
        return {
          item_category: (e && e.item_category) || "",
          item_category2: (e && e.item_category2) || "",
          item_category3: (e && e.item_category3) || "",
          item_list_name: (e && e.item_list_name) || t || "",
        };
      },
      c = {};
    function e() {
      let e = (() => {
          let e = {};
          return (
            (window.featuredItemsData || []).forEach(function (t) {
              e[t.sectionId] = t.items || [];
            }),
            (window.lookSpotlightData || []).forEach(function (t) {
              e[t.sectionId] = t.items || [];
            }),
            e
          );
        })(),
        a = [],
        n =
          (document.querySelectorAll(o).forEach(function (t) {
            ((t = t.id.replace("shopify-section-", "")), (t = e[t]));
            t &&
              t.forEach(function (t) {
                a.push(t);
              });
          }),
          r("landing-sections"));
      ((c = {}),
        a.forEach(function (t, e) {
          e = Object.assign({}, t, {
            index: e,
            item_category: n.item_category,
            item_category2: n.item_category2,
            item_category3: n.item_category3,
            item_list_name: n.item_list_name,
          });
          c[t.handle] = e;
        }));
      var t = a,
        i = "landing-sections";
      if (t && t.length) {
        let a = r(i);
        i = t.map(function (t, e) {
          return Object.assign({}, t, {
            index: e,
            item_category: a.item_category,
            item_category2: a.item_category2,
            item_category3: a.item_category3,
            item_list_name: a.item_list_name,
          });
        });
        ((window.dataLayer = window.dataLayer || []),
          window.dataLayer.push({ ecommerce: null }),
          window.dataLayer.push({
            event: "view_item_list",
            ecommerce: { item_list_name: a.item_list_name, items: i },
          }));
      }
    }
    ("loading" === document.readyState
      ? document.addEventListener("DOMContentLoaded", e)
      : e(),
      document.addEventListener("click", function (t) {
        if (!t.target.closest(".color-swatch-container")) {
          t = t.target.closest("product-card a[href]");
          if (t) {
            t = t.closest("product-card[handle]");
            if (t && t.closest(o)) {
              var t = t.getAttribute("handle"),
                e = c[t];
              if (e) {
                try {
                  sessionStorage.setItem(
                    "tracking_last_selected:" + t,
                    JSON.stringify({
                      index: e.index,
                      item_list_name: e.item_list_name,
                    }),
                  );
                } catch (t) {}
                ((window.dataLayer = window.dataLayer || []),
                  window.dataLayer.push({ ecommerce: null }),
                  window.dataLayer.push({
                    event: "select_item",
                    ecommerce: { item_list_name: e.item_list_name, items: [e] },
                  }));
              }
            }
          }
        }
      }));
  })(),
  document.addEventListener("wishlist:add", function (t) {
    var t = (t && t.detail) || {},
      e =
        window.productItemData &&
        window.productItemData.product_id == t.productId
          ? window.productItemData
          : null,
      t = e
        ? {
            item_id: e.item_id,
            item_name: e.item_name,
            item_brand: e.item_brand || "",
            coupon: e.coupon || "",
            discount: e.discount || 0,
            index: e.index || 0,
            item_category: e.item_category || "",
            item_category2: e.item_category2 || "",
            item_category3: e.item_category3 || "",
            item_list_name: e.item_list_name || "",
            variant: e.variant || "",
            size: e.size || "",
            price: e.price || 0,
            quantity: 1,
            sale: e.sale || "",
            perc_size_available: e.perc_size_available || "",
            size_not_available: e.size_not_available || "",
            season: e.season || "",
            new_arrival: e.new_arrival || "",
            continuos_product: e.continuos_product || "",
            brand_real: e.brand_real || "",
            handle: e.handle || "",
          }
        : {
            item_id: t.productId || "",
            item_name: t.productTitle || "",
            variant_id: t.variantId || "",
            quantity: 1,
          },
      a =
        (window.cartData && window.cartData.currency) ||
        window.productCurrency ||
        (window.pageContext && window.pageContext.currency) ||
        "",
      e = (e && e.price) || 0;
    ((window.dataLayer = window.dataLayer || []),
      window.dataLayer.push({ ecommerce: null }),
      window.dataLayer.push({
        event: "add_to_wishlist",
        ecommerce: { currency: a, value: e, items: [t] },
      }));
  }),
  (() => {
    function t() {
      Object.keys(o).forEach(function (n) {
        document.querySelectorAll(n).forEach(function (t) {
          var e, a;
          ((e = t),
            (a = o[n]),
            r.has(e) ||
              (r.add(e),
              new MutationObserver(function (t) {
                t.forEach(function (t) {
                  "attributes" === t.type &&
                    "open" === t.attributeName &&
                    null === t.oldValue &&
                    e.hasAttribute("open") &&
                    i(a);
                });
              }).observe(e, { attributes: !0, attributeOldValue: !0 })));
        });
      });
    }
    var i = function (t) {
        ((window.dataLayer = window.dataLayer || []),
          window.dataLayer.push({ event: "popup_impression", popup_name: t }));
      },
      o = {
        "size-chart-drawer": "sizeChartModal",
        "newsletter-popup": "newsletterPopup",
      },
      r = new WeakSet(),
      e =
        (t(),
        new MutationObserver(t).observe(document.body, {
          childList: !0,
          subtree: !0,
        }),
        !1);
    new MutationObserver(function () {
      var t;
      e ||
        ((t = document.querySelector(
          '[data-testid="form-component"], [data-component="form-component"]',
        )) &&
          "none" !== (t = window.getComputedStyle(t)).display &&
          "hidden" !== t.visibility &&
          ((e = !0), i("klaviyoPopup")));
    }).observe(document.body, {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style", "class"],
    });
  })());
